<template>
  <article 
    v-on:click="handleClick($event)"
    :class="{
      'card-flat':      true,
      'card--flipped':  isFlipped,
      'card--horizontal': orientation == 'horizontal',
      'card--vertical':   orientation != 'horizontal',
    }">
    <section class="card-panel">
      <section class="card-side-front">
        <slot name="card-front"></slot>
      </section>
      <section class="card-side-back">
        <slot name="card-back"></slot>
      </section>
    </section>
  </article>  
</template>

<script>
export default {
  props: [
    'isFlipped',
    'orientation',
    'click'
  ],
  methods: {
    handleClick(event) {
      if (this.click) this.click(event);
    }
  }
};
</script>

<style lang="scss">


.card-flat {
  transition: transform 1s;
  transform-style: preserve-3d;

  &.card--flipped {
    transform: rotateY(180deg);
  }

}

</style>



// WEBPACK FOOTER //
// photo-card.vue?5ed48e10